import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {CalendarPopover, DateInput} from 'sabre-spark'
import appConfig from 'config/applicationConfig'
import moment from 'moment'

export default class DatePicker extends Component {
    dateInputValueFormat = 'YYYY-MM-DD'
    calendarTitle = "Show Calendar"

    constructor(props) {
        super(props)
        this.dateElement = undefined
    }

    componentDidMount() {
        this.dateElement = new DateInput(this.dateInput, {
            onChange: (value) => {
                let dateValue = moment.utc(value, this.dateInputValueFormat, true)
                if (!dateValue.isValid()) return
                this.props.onChange(dateValue)
            },
            format: appConfig.dateDisplayFormat
        })
        new CalendarPopover(this.dateInput)
    }

    componentDidUpdate() {
        if (this.dateElement.getValue() === this.props.value.format(this.dateInputValueFormat)) return
        this.dateElement.setValue({
            day: this.props.value.date(),
            month: this.props.value.month() + 1,
            year: this.props.value.year()
        })
    }

    render() {
        return (
            <label className="spark-input spark-date example-simple-calendar" ref={c => this.dateInput = c}>
                <input className="spark-input__field" type="date"
                       defaultValue={this.props.value.format(this.dateInputValueFormat)}/>
                <span className="spark-label">{this.props.label}</span>
                <a className="spark-input__addon spark-date__calendar-toggle" title={this.calendarTitle}>
                    <i className="spark-icon-calendar spark-icon--md" />
                </a>
            </label>
        )
    }
}

DatePicker.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.instanceOf(moment).isRequired,
    label: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/shared/components/FormElements/DatePicker/index.js